export class PlacardToolKitsDtoResponse{
  cards: PlacardToolKitDetailDtoResponse[];
}

export class PlacardToolKitDetailDtoResponse {
  kitNo: string;
  description: string;
  tireNo: string;
  rearTireNo: string;
  showVehicles: boolean = false;
}

export class PlacardToolKitVehiclesDtoResponse {
  cards: PlacardToolKitVehicleDetailDtoResponse[];
}

export class PlacardToolKitVehicleDetailDtoResponse {
  vehicleOptionID: number;
  make: string;
  year: number;
  model: string;
  submodel: string;
  option: string;
  showPSILabel: boolean = false;
}

export class PlacardToolPSIsDtoResponse {
  cards: PlacardToolPSIDtoResponse[];
}

export class PlacardToolPSIDtoResponse {
  newPSIFront: string;
  newPSIRear: string;
  tireSize: string;
  load: string;
  position: string;
}
